export default {
	list: 'PowerBIReport',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			editable:false
		},
		Title: {
			class: 'value',
			dataName: 'Title',
			type: 'string',
			title: 'Title',
			width: 100,
			hidden: false,
			editable:false
		},
		ReportGUID:{
			class: 'value',
			dataName: 'ReportGUID',
			type: 'string',
			title: 'ReportGUID',
			width: 100,
			hidden: false,
			editable:false
		},
		DatasetGUID:{
			class: 'value',
			dataName: 'DatasetGUID',
			type: 'string',
			title: 'DatasetGUID',
			width: 100,
			hidden: false,
			editable:false
		},
	}
}